<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="exportDistributionRecordList"
            >导出记录</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="exportDistributionRecordDetailList"
            >导出分销商品列表</el-button
          >
          <div>
            <span>支付金额总计：</span>
            {{ payPrice.toFixed(2) }}
          </div>
          <div>
            <span>佣金金额总计：</span>
            {{ distributionFee.toFixed(2) }}
          </div>
        </div>
        <div class="header-right">
          <!-- <div>
            <span>用户ID：</span>
            <el-input
              v-model="referId"
              size="small"
              placeholder="请输入用户ID"
            ></el-input>
          </div> -->
          <div>
            <span>时间类型：</span>
            <el-radio-group v-model="timeField">
              <el-radio label="createTime">创建时间</el-radio>
              <el-radio label="distributionTime">分成时间</el-radio>
            </el-radio-group>
          </div>
          <div>
            <span>手机号：</span>
            <el-input
              v-model="referPhone"
              size="small"
              placeholder="请输入手机号"
            ></el-input>
          </div>
          <div>
            <span>状态：</span>
            <el-select v-model="status" size="small" placeholder="请选择分销状态">
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <!-- <div>
            <span>订单ID：</span>
            <el-input
              v-model="mallOrderId"
              size="small"
              placeholder="请输入订单号"
            ></el-input>
          </div> -->
          <div>
            <span>订单号：</span>
            <el-input
              v-model="tradeNo"
              size="small"
              placeholder="请输入订单号"
            ></el-input>
          </div>
          <div>
            <span>时间：</span>
            <el-date-picker
              v-model="time"
              size="small"
              type="daterange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            >
            </el-date-picker>
          </div>
          <el-button type="primary" size="small" @click="searchDistribution"
            >查询</el-button
          >
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="distributionList" style="width: 100%">
            <!-- <el-table-column label="id" align="left">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.id }}</div>
              </template>
            </el-table-column> -->
            <!-- <el-table-column label="用户ID" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.referId }}</div>
              </template>
            </el-table-column> -->
            <el-table-column :label="isDsType ? '推荐者手机号' : '团长'" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.referPhone }}</div>
              </template>
            </el-table-column>
            <el-table-column
              :label="isDsType ? '消费者手机号（ID）' : '用户ID'"
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <div class="name">
                  {{ scope.row.userPhone }}（{{ scope.row.userId }}）
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="订单ID" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.mallOrderId }}</div>
              </template>
            </el-table-column> -->
            <el-table-column label="订单编号" width="300" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.tradeNo }}</div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="消费人ID" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.userId }}</div>
              </template>
            </el-table-column> -->
            <el-table-column label="奖励金额" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.distributioFee }}</div>
              </template>
            </el-table-column>
            <el-table-column label="商品原价" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.originGoodsPrice }}</div>
              </template>
            </el-table-column>
            <el-table-column label="支付金额" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.payPrice }}</div>
              </template>
            </el-table-column>
            <el-table-column label="记录生成时间" width="250" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.createTime }}</div>
              </template>
            </el-table-column>
            <el-table-column label="分成时间" width="250" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.distributionTime }}</div>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <div
                  class="status"
                  :class="{
                    suc: scope.row.status == 2,
                    fail: scope.row.status == 0,
                    fail: scope.row.status == 1,
                    fail: scope.row.status == 3,
                  }"
                >
                  {{ statusObj[scope.row.status] }}
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDistributionList,
  getDistributionListCount,
  exportDistributionRecordList,
  exportDistributionRecordDetailList,
} from "@/api/index.js";
import { mapState } from "vuex";
import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      statusList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "未成交",
          value: 0,
        },
        {
          label: "待分成",
          value: 1,
        },
        {
          label: "已分成",
          value: 2,
        },
        {
          label: "已退款",
          value: 3,
        },
      ],
      statusObj: {
        0: "未成交",
        1: "待分成",
        2: "已分成",
        3: "已退款",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      distributionList: [],
      pageSize: 10,
      pageCount: 0,
      pageNo: 1,
      status: "",
      referPhone: "",
      timeField: "createTime",
      referId: "",
      mallOrderId: "",
      tradeNo: "",
      time: "",
      startTime: "",
      endTime: "",
      currentStatus: "",
      currentMallOrderId: "",
      currentStartTime: "",
      currentEndTime: "",
      distributionFee: 0,
      payPrice: 0,
    };
  },
  watch: {
    time(val) {
      console.log(val);
      if (val) {
        this.startTime = new Date(val[0]).pattern("yyyy-MM-dd");
        this.endTime = new Date(val[1]).pattern("yyyy-MM-dd");
      } else {
        this.startTime = "";
        this.endTime = "";
      }
    },
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.pageNo = 1;
      this.getDistributionList();
      // this.getDistributionListCount();
    },
    getDistributionList() {
      getDistributionList({
        pageNo: this.pageNo,
        row: this.pageSize,
        status: this.status,
        referPhone: this.referPhone,
        timeField: this.timeField,
        referId: this.referId,
        mallOrderId: this.mallOrderId,
        tradeNo: this.tradeNo,
        startTime: this.startTime,
        endTime: this.endTime,
        order: "id desc",
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data.count;
          this.distributionList = res.data.list;
          this.distributionFee = res.data.distributioFee;
          this.payPrice = res.data.payPrice;
        }
        if (res.code == -1) {
          this.distributionList = [];
        }
      });
    },
    getDistributionListCount() {
      getDistributionListCount({
        status: this.status,
        referPhone: this.referPhone,
        timeField: this.timeField,
        referId: this.referId,
        mallOrderId: this.mallOrderId,
        tradeNo: this.tradeNo,
        startTime: this.startTime,
        endTime: this.endTime,
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data;
        }
        if (res.code == -1) {
          this.pageCount = 0;
        }
      });
    },
    searchDistribution() {
      this.currentStatus = this.status;
      this.currentMallOrderId = this.mallOrderId;
      this.currentStartTime = this.startTime;
      this.currentEndTime = this.endTime;
      this.getPageData();
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getDistributionList();
    },
    exportDistributionRecordList() {
      if (!this.distributionList.length) {
        return this.$notify.warning("没有数据可以导出");
      }
      location.href = exportDistributionRecordList({
        row: 99999,
        status: this.currentStatus,
        mallOrderId: this.currentMallOrderId,
        startTime: this.currentStartTime,
        endTime: this.currentEndTime,
      });
    },
    exportDistributionRecordDetailList() {
      if (!this.distributionList.length) {
        return this.$notify.warning("没有数据可以导出");
      }
      location.href = exportDistributionRecordDetailList({
        row: 99999,
        status: this.currentStatus,
        mallOrderId: this.currentMallOrderId,
        startTime: this.currentStartTime,
        endTime: this.currentEndTime,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .header-left {
    height: 30px;
    align-items: center;
    & > div {
      margin-left: 20px;
    }
  }
  .header-right {
    line-height: 32px;
    margin-top: 20px;
    & > div {
      .el-input {
        display: inline-block;
        width: 130px;
      }
    }
    & > div + div {
      margin-left: 10px;
    }
    .el-button {
      margin-left: 10px;
    }
  }
  .upload-xls {
    margin: 0 10px;
  }
  .list {
    width: 100%;
    padding: 0 20px;
    .template-name {
      color: #66b1ff;
      cursor: pointer;
    }
    .status {
      display: inline-block;
      width: 70px;
      margin-right: 5px;
      &.ing {
        color: #ffaa00;
      }
      &.suc {
        color: #7abd54;
      }
      &.fail {
        color: #ff4c4c;
      }
    }
  }
  .tips {
    border: 1px solid #ff9191;
    background-color: #ffe6e6;
    display: block;
    position: relative;
    color: #666;
    font-size: 12px;
    line-height: 30px;
    padding: 8px;
    border-radius: 3px;
    .em {
      color: #3388ff;
    }
  }
}
.popover {
  .title {
    line-height: 30px;
  }
  .content {
    color: #66b1ff;
  }
}
</style>

<style lang="less">
.upload-xls-btn {
  display: inline-block;
  margin: 0 10px;
}
</style>
